import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import React, { FC } from "react";

const Alert: FC<AlertProps> = (props) => {
  return (
    <MuiAlert
      iconMapping={{ success: <CheckCircleOutlineIcon fontSize="inherit" /> }}
      {...props}
    />
  );
};

export default Alert;
